module.exports = __webpack_public_path__ + "static/media/account.17a95f61.svg";